
// utils/getApartmentImage.js
export function getApartmentImage(apartment) {
  if (apartment?.featuredImages?.length) {
    return apartment.featuredImages[0];
  }

  if (apartment?.images?.length) {
    const first = apartment.images[0];
    return typeof first === "string" ? first : first?.url;
  }

  if (typeof apartment?.image === "string") {
    return apartment.image;
  }

  return "/assets/images/placeholder.jpg";
}
